const alphabet = 'abcdefghijklmnopqrstuvwxyz';
const numbers = '0123456789';

/**
 * Generates a CUID (Collision-Resistant ID) that is 25 characters long.
 *
 * The format is:
 * - 8 characters: Random lowercase letters and numbers.
 * - 4 characters: Current timestamp in milliseconds (base 36).
 * - 5 characters: Random lowercase letters and numbers.
 * - 8 characters: Random lowercase letters and numbers.
 *
 * @returns {string} The generated CUID.
 */
export function cuid(): string {
  const timestamp = Date.now().toString(36);

  const randomChars = (length: number): string => {
    let result = '';
    const characters = alphabet + numbers;
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  return randomChars(8) + timestamp.padStart(4, '0') + randomChars(5) + randomChars(8);
}
